import { graphql, useSuspenseQuery } from '@biscuits/graphql';
const userInfoQuery = graphql(`
	query UserInfo($userId: ID!) {
		user(id: $userId) {
			id
			name
			imageUrl
		}
	}
`);
export function useUserInfo(userId) {
    var _a;
    const { data } = useSuspenseQuery(userInfoQuery, {
        variables: { userId },
    });
    return (_a = data === null || data === void 0 ? void 0 : data.user) !== null && _a !== void 0 ? _a : null;
}
//# sourceMappingURL=useUserInfo.js.map